<template>
  <section class="mt-2">
    <AcighModel
      :agent="selectedAgent"
      @save="saveSelectedInteractions"
      :loading="loadingAcgihModal"
      :showAllOptions="false"
    ></AcighModel>

    <SuggestionForImprovement
      :legalSearch="legalSearch"
      @save="saveSelectedInteractions"
      :loading="loadingAcgihModal"
    ></SuggestionForImprovement>

    <AcceptInformationTab></AcceptInformationTab>

    <TabButtons></TabButtons>

    <modal-confirm-action
      variant='danger'
      refModal='archiveRole'
      idModal='archiveRole'
      :loading='loadingArchive'
      :description='descriptionArchive'
      :title='titleArchive'
      @confirmed='archiveRole'
    />

    <ArchivedRoles
      :sectorId='archivedRolesSectorId'
      :tab='tabName'
      @update='init'
    >
    </ArchivedRoles>

    <AgentPercentage
      :productId='productId'
      @update-agents='init'
    >
    </AgentPercentage>

    <b-overlay
      :show="loadingRoles || lookingForAgentsNotLinkedToProductAndRole"
      rounded
      no-center
      opacity="0.7"
      spinner-small
      spinner-variant="primary"
      class="d-inline-block w-100"
    >
      <section v-if="importedCompany && importedCompany._id" class="mb-5">
        <section v-if='sectors && sectors.length > 0' class='w-100 mt-3'>
          <section v-for='sector in sectors' :key='sector._id' class='mb-1'>
            <section :id='sector._id'>
              <section class='sector d-flex align-items-center justify-content-between'>
                <section class='ml-3'>
                  <span class='name'>Setor - {{ sector.name }}</span>
                </section>

                <section class='mr-3 d-flex align-items-center'>
                  <!--Ver cargos arquivados-->
                  <b-popover
                    :target='`${sector._id}_archivedRoles`'
                    placement='top'
                    triggers='hover'
                  >
                    <span>
                      Clique para ver os cargos arquivados do setor
                    </span>
                  </b-popover>
                  <button
                    :id='`${sector._id}_archivedRoles`'
                    class='btn-information-filled-in mr-2'
                    @click='showModalArchivedRoles(sector, $event)'
                  >
                    <svg
                      width='19'
                      height='19'
                      viewBox='0 0 16 16'
                      class='bi bi-archive'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path d='M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 12.5V5a1 1 0 0 1-1-1V2zm2 3v7.5A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5V5H2zm13-3H1v2h14V2zM5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z' />
                    </svg>
                  </button>

                  <button class='btn-expand-collapse-navy-blue' :class="sector.open ? '' : 'pulse-global'" @click='toggleSectorOpen(sector._id)'>
                    {{ sector.open ? 'Recolher informações' : 'Expandir informações' }}
                  </button>
                </section>
              </section>

              <section
                v-show='sector.open'
                v-for='sectorRole in sector.sectorsRoles'
                :key='sectorRole._id'
                class='margin-left-25'
              >
                <section :id='sectorRole._id' v-if='sectorRole && sectorRole.role'>
                  <section class='cargo-header d-flex align-items-center justify-content-between px-3 py-2'>
                    <section>
                      <span class='cargo-name'>Cargo - {{ sectorRole.role.name }}</span>
                    </section>

                    <section class='d-flex align-items-center'>
                      <!--Arquivar cargo-->
                      <b-popover
                        :target='`${sectorRole._id}_archiveRole`'
                        placement='top'
                        triggers='hover'
                      >
                        <span>
                          Clique para arquivar o cargo e as informações dele neste setor
                        </span>
                      </b-popover>
                      <button
                        :id='`${sectorRole._id}_archiveRole`'
                        class='btn-information-filled-in d-flex align-items-center justify-content-center mr-2'
                        @click='showModalArchiveRole(sectorRole, sector, $event)'
                      >
                        <svg
                          width='19'
                          height='19'
                          viewBox='0 0 16 16'
                          class='bi bi-archive'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path d='M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 12.5V5a1 1 0 0 1-1-1V2zm2 3v7.5A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5V5H2zm13-3H1v2h14V2zM5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z' />
                        </svg>
                      </button>

                      <button class='btn-expand-collapse-navy-blue' :class="sectorRole.open ? '' : 'pulse-global'" @click='toggleSectorRoleOpen(sectorRole._id)'>
                        {{ sectorRole.open ? 'Recolher informações' : 'Expandir informações' }}
                      </button>
                    </section>
                  </section>

                  <section v-if='sectorRole && sectorRole.open' class='margin-left-25'>
                    <!-- ===== RISCOS QUÍMICOS ===== -->
                    <section v-if="sectorRole.role && sectorRole.role.rolesProductsLegalConsultation && sectorRole.role.rolesProductsLegalConsultation.length > 0" class='risk-chemical d-flex align-items-center justify-content-between px-3 py-2'>
                      <strong class='risk-text'>Riscos Químicos</strong>
                      <button class='btn-expand-collapse-navy-blue' :class="sectorRole.chemicalRiskOpen ? '' : 'pulse-global'" @click="toggleRiskOpen(sectorRole, 'chemicalRiskOpen')">
                        {{ sectorRole.chemicalRiskOpen ? 'Recolher informações' : 'Expandir informações' }}
                      </button>
                    </section>

                    <section v-if='sectorRole.chemicalRiskOpen' class='transition margin-left-25'>
                      <section
                        v-for='roleProductLegalConsultation in sectorRole.role.rolesProductsLegalConsultation'
                        :key='roleProductLegalConsultation._id'
                      >
                        <section
                          v-if='roleProductLegalConsultation && roleProductLegalConsultation.product'
                          :id='roleProductLegalConsultation._id'
                          class='product'
                        >
                          <section
                            class='product d-flex align-items-center justify-content-between'
                            style='background: #DADADA'
                          >
                            <section class='d-flex align-items-center justify-content-start h-100 ml-3'>
                              <img
                                :src="require('@/assets/images/product-chemical.svg')"
                                width="32"
                                height="28"
                                alt="Produto químico"
                              />

                              <span class='name ml-2'>
                                Produto: {{ roleProductLegalConsultation.product.name }}
                              </span>
                            </section>

                            <section class='d-flex align-items-center justify-content-between mr-3'>
                              <b-popover
                                custom-class=''
                                :target='`${roleProductLegalConsultation.product._id}_percentage`'
                                placement='top'
                                triggers='hover'
                              >
                                <span class='label'>
                                  Clique para editar/cadastrar a porcentagem do produto em cada agente
                                </span>
                              </b-popover>
                              <button
                                :id='`${roleProductLegalConsultation.product._id}_percentage`'
                                :class="!!(roleProductLegalConsultation.product.legalSearches && roleProductLegalConsultation.product.legalSearches.find((x) => !x.percentage || x.percentage <= 0)) ? 'btn-termsofuses-not-filled mr-2' : 'btn-termsofuses mr-2'"
                                @click='showModalAgentPercentage(roleProductLegalConsultation.product)'
                              >
                                <svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 24 24'
                                     fill='none'>
                                  <path
                                    d='M18.5 3.5L3.5 18.501L5.496 20.497L20.496 5.497L18.5 3.5ZM7.001 5C6.73836 4.99974 6.47823 5.05121 6.23548 5.15148C5.99273 5.25174 5.7721 5.39884 5.5862 5.58437C5.4003 5.7699 5.25276 5.99023 5.15201 6.23279C5.05125 6.47534 4.99926 6.73536 4.999 6.998C4.99874 7.26064 5.05021 7.52077 5.15048 7.76352C5.25074 8.00627 5.39784 8.2269 5.58337 8.4128C5.7689 8.5987 5.98923 8.74624 6.23179 8.84699C6.47434 8.94775 6.73436 8.99974 6.997 9C7.52743 9.00053 8.03635 8.79033 8.4118 8.41563C8.78725 8.04093 8.99847 7.53243 8.999 7.002C8.99953 6.47157 8.78933 5.96265 8.41463 5.5872C8.03993 5.21175 7.53143 5.00053 7.001 5ZM17.001 15C16.4706 14.9995 15.9616 15.2097 15.5862 15.5844C15.2108 15.9591 14.9995 16.4676 14.999 16.998C14.9985 17.5284 15.2087 18.0374 15.5834 18.4128C15.9581 18.7882 16.4666 18.9995 16.997 19C17.2596 19.0003 17.5198 18.9488 17.7625 18.8485C18.0053 18.7483 18.2259 18.6012 18.4118 18.4156C18.5977 18.2301 18.7452 18.0098 18.846 17.7672C18.9467 17.5247 18.9987 17.2646 18.999 17.002C18.9993 16.7394 18.9478 16.4792 18.8475 16.2365C18.7473 15.9937 18.6002 15.7731 18.4146 15.5872C18.2291 15.4013 18.0088 15.2538 17.7662 15.153C17.5237 15.0523 17.2636 15.0003 17.001 15Z'
                                    fill='#022245' />
                                </svg>
                              </button>

                              <button class='btn-expand-collapse-navy-blue ml-2' :class="roleProductLegalConsultation.product.open ? '' : 'pulse-global'" @click='toggleProductOpen(roleProductLegalConsultation.product)'>
                                {{ roleProductLegalConsultation.product.open ? 'Recolher informações' : 'Expandir informações' }}
                              </button>
                            </section>
                          </section>
                          <table
                            v-if='roleProductLegalConsultation && roleProductLegalConsultation.product && roleProductLegalConsultation.product.open'
                            class='w-100 text-center' style='margin-top: -2px;'
                          >
                            <thead class='py-3'>
                            <tr class='headerTable'>
                              <th class='width-10-percent'>Ações</th>
                              <th class='width-20-percent'>CAS: Agente</th>
                              <th class='width-30-percent'>Limites (referência)</th>
                              <th class='width-40-percent'>Relevância toxicológica (referência)</th>
                            </tr>
                            </thead>
                            <tbody>
                            <template v-for='legalSearch in roleProductLegalConsultation.product.legalSearches_'>
                              <template v-if='!legalSearch.acgih'>
                                <tr :key="`${legalSearch.cas}-${legalSearch.index}-${sectorRole._id}-chem-not-acgih`">
                                  <td class='table-td'>
                                    <b-icon
                                      @click='showModalSuggestionForImprovement(legalSearch)'
                                      class='cursor-pointer'
                                      font-scale='1.5'
                                      icon='pencil-square'
                                      color='#262626'
                                    >
                                    </b-icon>
                                  </td>

                                  <td class='table-td'>
                                    <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                                  </td>

                                  <td colspan='2' class='table-td'>
                                    O agente foi classificado, porém não apresentou enquadramento para a ACGIH.
                                  </td>
                                </tr>
                              </template>

                              <template
                                v-else-if="model.getInteractions(legalSearch) === 'one-interaction' || model.getInteractions(legalSearch) === 'none-interaction'">
                                <tr :key="`${legalSearch.legalSearchId}-${roleProductLegalConsultation.product._id}-${sectorRole._id}-chem-interaction`">
                                  <td class='table-td'>
                                    <b-icon
                                      @click='showModalSuggestionForImprovement(legalSearch)'
                                      class='cursor-pointer'
                                      font-scale='1.5'
                                      icon='pencil-square'
                                      color='#262626'
                                    >
                                    </b-icon>
                                  </td>

                                  <td class='table-td'>
                                    <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                                    <a
                                      href='#'
                                      v-b-tooltip.lefttop.hover.html
                                      :title="model.getValue('interactions', legalSearch, 1)"
                                      v-if="model.getValue('interactions', legalSearch, 1) != '-'"
                                      @click='displayInteractions(legalSearch)'
                                    >
                                      <span style='' class='d-flex justify-content-center'>
                                        Especificações
                                        <b-icon
                                          class='ml-1'
                                          font-scale='1.2'
                                          icon='info-circle-fill'
                                          variant='info'
                                        >
                                        </b-icon>
                                      </span>
                                    </a>
                                  </td>

                                  <td class='table-td  '>
                                    <section class='pl-4'>
                                      <ul style='text-align: left' class='limits'>
                                        <li>
                                          <strong>8h ou TWA: </strong>
                                          <span class=''>{{ getInformationTwa(legalSearch) }}</span>
                                        </li>
                                        <li>
                                          <strong>15 min ou STEL: </strong>
                                          <span class=''>{{ getInformationStel(legalSearch) }}</span>
                                        </li>
                                      </ul>
                                    </section>
                                  </td>

                                  <td class='table-td'>
                                    <section class='pl-4'>
                                      <ul style='text-align: left' class='limits'>
                                        <li>
                                          <strong>ACGIH: </strong>
                                          <span class=''>{{ formatNotationsBaseDoTlv(legalSearch) }}</span>
                                        </li>
                                      </ul>
                                    </section>
                                  </td>
                                </tr>
                              </template>

                              <template v-else-if="model.getInteractions(legalSearch) === 'select-interaction'">
                                <tr :key="`${legalSearch.legalSearchId}-${roleProductLegalConsultation.product._id}-${sectorRole._id}-chem-select-interaction`">
                                  <td class='table-td'>
                                    <b-icon
                                      @click='showModalSuggestionForImprovement(legalSearch)'
                                      class='cursor-pointer'
                                      font-scale='1.5'
                                      icon='pencil-square'
                                      color='#262626'
                                    >
                                    </b-icon>
                                  </td>

                                  <td class='table-td'>
                                    <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                                  </td>

                                  <td colspan='2' class='table-td  '>
                                    <a href='#' @click='displayInteractions(legalSearch)'>
                                      Agente necessita de determinação de fração ou forma de
                                      exposição, selecione aqui
                                    </a>
                                  </td>
                                </tr>
                              </template>
                            </template>
                            </tbody>
                          </table>
                        </section>
                      </section>
                    </section>

                    <!-- ===== RISCOS FÍSICOS ===== -->
                    <section v-if="getRolesLegalsearches(sectorRole, 'fisico')" class='risk-physical d-flex align-items-center justify-content-between px-3 py-2'>
                      <strong class='risk-text'>Riscos Físicos</strong>
                      <button class='btn-expand-collapse-navy-blue' :class="sectorRole.physicalRiskOpen ? '' : 'pulse-global'" @click="toggleRiskOpen(sectorRole, 'physicalRiskOpen')">
                        {{ sectorRole.physicalRiskOpen ? 'Recolher informações' : 'Expandir informações' }}
                      </button>
                    </section>

                    <table v-if="sectorRole.physicalRiskOpen && getRolesLegalsearches(sectorRole, 'fisico')" class='w-100 text-center transition' style='margin-top: -2px;'>
                      <thead class='py-3'>
                      <tr class='headerTable'>
                        <th class='width-10-percent'>Ações</th>
                        <th class='width-20-percent'>CAS: Agente</th>
                        <th class='width-30-percent'>Limites (referência)</th>
                        <th class='width-40-percent'>Relevância toxicológica (referência)</th>
                      </tr>
                      </thead>
                      <tbody>
                      <template v-for="legalSearch in getAgentsByRisk(sectorRole, 'fisico')">
                        <template v-if='!legalSearch.acgih'>
                          <tr :key="`${legalSearch.cas}-${legalSearch.index}-${sectorRole._id}-phys-not-acgih`">
                            <td class='table-td'>
                              <b-icon
                                @click='showModalSuggestionForImprovement(legalSearch)'
                                class='cursor-pointer'
                                font-scale='1.5'
                                icon='pencil-square'
                                color='#262626'
                              >
                              </b-icon>
                            </td>

                            <td class='table-td'>
                              <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                            </td>

                            <td colspan='2' class='table-td'>
                              O agente foi classificado, porém não apresentou enquadramento para a ACGIH.
                            </td>
                          </tr>
                        </template>

                        <template
                          v-else-if="model.getInteractions(legalSearch) === 'one-interaction' || model.getInteractions(legalSearch) === 'none-interaction'">
                          <tr :key="`${legalSearch.legalSearchId}-${sectorRole._id}-phys-interaction`">
                            <td class='table-td'>
                              <b-icon
                                @click='showModalSuggestionForImprovement(legalSearch)'
                                class='cursor-pointer'
                                font-scale='1.5'
                                icon='pencil-square'
                                color='#262626'
                              >
                              </b-icon>
                            </td>

                            <td class='table-td'>
                              <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                              <a
                                href='#'
                                v-b-tooltip.lefttop.hover.html
                                :title="model.getValue('interactions', legalSearch, 1)"
                                v-if="model.getValue('interactions', legalSearch, 1) != '-'"
                                @click='displayInteractions(legalSearch)'
                              >
                                <span style='' class='d-flex justify-content-center'>
                                  Especificações
                                  <b-icon
                                    class='ml-1'
                                    font-scale='1.2'
                                    icon='info-circle-fill'
                                    variant='info'
                                  >
                                  </b-icon>
                                </span>
                              </a>
                            </td>

                            <td class='table-td  '>
                              <section class='pl-4'>
                                <ul style='text-align: left' class='limits'>
                                  <li>
                                    <strong>8h ou TWA: </strong>
                                    <span class=''>{{ getInformationTwa(legalSearch) }}</span>
                                  </li>
                                  <li>
                                    <strong>15 min ou STEL: </strong>
                                    <span class=''>{{ getInformationStel(legalSearch) }}</span>
                                  </li>
                                </ul>
                              </section>
                            </td>

                            <td class='table-td'>
                              <section class='pl-4'>
                                <ul style='text-align: left' class='limits'>
                                  <li>
                                    <strong>ACGIH: </strong>
                                    <span class=''>{{ formatNotationsBaseDoTlv(legalSearch) }}</span>
                                  </li>
                                </ul>
                              </section>
                            </td>
                          </tr>
                        </template>

                        <template v-else-if="model.getInteractions(legalSearch) === 'select-interaction'">
                          <tr :key="`${legalSearch.legalSearchId}-${sectorRole._id}-phys-select-interaction`">
                            <td class='table-td'>
                              <b-icon
                                @click='showModalSuggestionForImprovement(legalSearch)'
                                class='cursor-pointer'
                                font-scale='1.5'
                                icon='pencil-square'
                                color='#262626'
                              >
                              </b-icon>
                            </td>

                            <td class='table-td'>
                              <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                            </td>

                            <td colspan='2' class='table-td  '>
                              <a href='#' @click='displayInteractions(legalSearch)'>
                                Agente necessita de determinação de fração ou forma de
                                exposição, selecione aqui
                              </a>
                            </td>
                          </tr>
                        </template>
                      </template>
                      </tbody>
                    </table>

                    <!-- ===== RISCOS BIOLÓGICOS ===== -->
                    <section v-if="getRolesLegalsearches(sectorRole, 'biologico')" class='risk-biological d-flex align-items-center justify-content-between px-3 py-2'>
                      <strong class='risk-text'>Riscos Biológicos</strong>
                      <button class='btn-expand-collapse-navy-blue' :class="sectorRole.biologicalRiskOpen ? '' : 'pulse-global'" @click="toggleRiskOpen(sectorRole, 'biologicalRiskOpen')">
                        {{ sectorRole.biologicalRiskOpen ? 'Recolher informações' : 'Expandir informações' }}
                      </button>
                    </section>

                    <table v-if="sectorRole.biologicalRiskOpen && getRolesLegalsearches(sectorRole, 'biologico')" class='w-100 text-center transition' style='margin-top: -2px;'>
                      <thead class='py-3'>
                      <tr class='headerTable'>
                        <th class='width-10-percent'>Ações</th>
                        <th class='width-20-percent'>CAS: Agente</th>
                        <th class='width-30-percent'>Limites (referência)</th>
                        <th class='width-40-percent'>Relevância toxicológica (referência)</th>
                      </tr>
                      </thead>
                      <tbody>
                      <template v-for="legalSearch in getAgentsByRisk(sectorRole, 'biologico')">
                        <template v-if='!legalSearch.acgih'>
                          <tr :key="`${legalSearch.cas}-${legalSearch.index}-${sectorRole._id}-bio-not-acgih`">
                            <td class='table-td'>
                              <b-icon
                                @click='showModalSuggestionForImprovement(legalSearch)'
                                class='cursor-pointer'
                                font-scale='1.5'
                                icon='pencil-square'
                                color='#262626'
                              >
                              </b-icon>
                            </td>

                            <td class='table-td'>
                              <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                            </td>

                            <td colspan='2' class='table-td'>
                              O agente foi classificado, porém não apresentou enquadramento para a ACGIH.
                            </td>
                          </tr>
                        </template>

                        <template
                          v-else-if="model.getInteractions(legalSearch) === 'one-interaction' || model.getInteractions(legalSearch) === 'none-interaction'">
                          <tr :key="`${legalSearch.legalSearchId}-${sectorRole._id}-bio-interaction`">
                            <td class='table-td'>
                              <b-icon
                                @click='showModalSuggestionForImprovement(legalSearch)'
                                class='cursor-pointer'
                                font-scale='1.5'
                                icon='pencil-square'
                                color='#262626'
                              >
                              </b-icon>
                            </td>

                            <td class='table-td'>
                              <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                              <a
                                href='#'
                                v-b-tooltip.lefttop.hover.html
                                :title="model.getValue('interactions', legalSearch, 1)"
                                v-if="model.getValue('interactions', legalSearch, 1) != '-'"
                                @click='displayInteractions(legalSearch)'
                              >
                                <span style='' class='d-flex justify-content-center'>
                                  Especificações
                                  <b-icon
                                    class='ml-1'
                                    font-scale='1.2'
                                    icon='info-circle-fill'
                                    variant='info'
                                  >
                                  </b-icon>
                                </span>
                              </a>
                            </td>

                            <td class='table-td  '>
                              <section class='pl-4'>
                                <ul style='text-align: left' class='limits'>
                                  <li>
                                    <strong>8h ou TWA: </strong>
                                    <span class=''>{{ getInformationTwa(legalSearch) }}</span>
                                  </li>
                                  <li>
                                    <strong>15 min ou STEL: </strong>
                                    <span class=''>{{ getInformationStel(legalSearch) }}</span>
                                  </li>
                                </ul>
                              </section>
                            </td>

                            <td class='table-td'>
                              <section class='pl-4'>
                                <ul style='text-align: left' class='limits'>
                                  <li>
                                    <strong>ACGIH: </strong>
                                    <span class=''>{{ formatNotationsBaseDoTlv(legalSearch) }}</span>
                                  </li>
                                </ul>
                              </section>
                            </td>
                          </tr>
                        </template>

                        <template v-else-if="model.getInteractions(legalSearch) === 'select-interaction'">
                          <tr :key="`${legalSearch.legalSearchId}-${sectorRole._id}-bio-select-interaction`">
                            <td class='table-td'>
                              <b-icon
                                @click='showModalSuggestionForImprovement(legalSearch)'
                                class='cursor-pointer'
                                font-scale='1.5'
                                icon='pencil-square'
                                color='#262626'
                              >
                              </b-icon>
                            </td>

                            <td class='table-td'>
                              <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                            </td>

                            <td colspan='2' class='table-td  '>
                              <a href='#' @click='displayInteractions(legalSearch)'>
                                Agente necessita de determinação de fração ou forma de
                                exposição, selecione aqui
                              </a>
                            </td>
                          </tr>
                        </template>
                      </template>
                      </tbody>
                    </table>
                  </section>
                </section>
              </section>
            </section>
          </section>
        </section>

        <section v-if='rolesHierarchy && rolesHierarchy.length > 0'>
          <hr/>
        </section>

        <section v-if='rolesHierarchy && rolesHierarchy.length > 0' class='w-100'>
          <section class='risk-chemical d-flex align-items-center justify-content-center pt-3 pb-1 text-center w-100'>
            <h6><strong>Agentes vinculados a produtos e cargos sem setor.</strong></h6>
          </section>

          <section
            v-for='roleItem in rolesHierarchy'
            :key='roleItem._id'
            class='margin-left-25 mb-1'
          >
                <section :id='roleItem._id' v-if='roleItem && roleItem.role'>
                  <section class='cargo-header d-flex align-items-center justify-content-between px-3 py-2'>
                    <section>
                      <span class='cargo-name'>Cargo - {{ roleItem.role.name }}</span>
                    </section>

                    <section class='d-flex align-items-center'>

                      <button class='btn-expand-collapse-navy-blue' :class="roleItem.open ? '' : 'pulse-global'" @click='toggleRoleOpen(roleItem)'>
                        {{ roleItem.open ? 'Recolher informações' : 'Expandir informações' }}
                      </button>
                    </section>
                  </section>

                  <section v-if='roleItem && roleItem.open' class='margin-left-25'>
                    <!-- ===== RISCOS QUÍMICOS ===== -->
                    <section v-if="roleItem.role && roleItem.role.rolesProductsLegalConsultation && roleItem.role.rolesProductsLegalConsultation.length > 0" class='risk-chemical d-flex align-items-center justify-content-between px-3 py-2'>
                      <strong class='risk-text'>Riscos Químicos</strong>
                      <button class='btn-expand-collapse-navy-blue' :class="roleItem.chemicalRiskOpen ? '' : 'pulse-global'" @click="toggleRoleRiskOpen(roleItem, 'chemicalRiskOpen')">
                        {{ roleItem.chemicalRiskOpen ? 'Recolher informações' : 'Expandir informações' }}
                      </button>
                    </section>

                    <section v-if='roleItem.chemicalRiskOpen' class='transition margin-left-25'>
                      <section
                        v-for='(roleProductLegalConsultation, indexRoleProduct) in roleItem.role.rolesProductsLegalConsultation'
                        :key='roleProductLegalConsultation._id'
                      >
                        <hr v-if='indexRoleProduct > 0' />
                        <section
                          v-if='roleProductLegalConsultation && roleProductLegalConsultation.product'
                          :id='roleProductLegalConsultation._id'
                          class='product'
                        >
                          <section
                            class='product d-flex align-items-center justify-content-between'
                            style='background: #DADADA'
                          >
                            <section class='d-flex align-items-center justify-content-start h-100 ml-3'>
                              <img
                                :src="require('@/assets/images/product-chemical.svg')"
                                width="32"
                                height="28"
                                alt="Produto químico"
                              />

                              <span class='name ml-2'>
                                Produto: {{ roleProductLegalConsultation.product.name }}
                              </span>
                            </section>

                            <section class='d-flex align-items-center justify-content-between mr-3'>
                              <button class='btn-expand-collapse-navy-blue ml-2' :class="roleProductLegalConsultation.product.open ? '' : 'pulse-global'" @click='toggleRoleProductOpen(roleProductLegalConsultation.product)'>
                                {{ roleProductLegalConsultation.product.open ? 'Recolher informações' : 'Expandir informações' }}
                              </button>
                            </section>
                          </section>
                          <table
                            v-if='roleProductLegalConsultation && roleProductLegalConsultation.product && roleProductLegalConsultation.product.open'
                            class='w-100 text-center' style='margin-top: -2px;'
                          >
                            <thead class='py-3'>
                            <tr class='headerTable'>
                              <th class='width-10-percent'>Ações</th>
                              <th class='width-20-percent'>CAS: Agente</th>
                              <th class='width-30-percent'>Limites (referência)</th>
                              <th class='width-40-percent'>Relevância toxicológica (referência)</th>
                            </tr>
                            </thead>
                            <tbody>
                            <template v-for='legalSearch in roleProductLegalConsultation.product.legalSearches_'>
                              <template v-if='!legalSearch.acgih'>
                                <tr :key="`${legalSearch.cas}-${legalSearch.index}-${roleItem._id}-chem-not-acgih`">
                                  <td class='table-td'>
                                    <b-icon
                                      @click='showModalSuggestionForImprovement(legalSearch)'
                                      class='cursor-pointer'
                                      font-scale='1.5'
                                      icon='pencil-square'
                                      color='#262626'
                                    >
                                    </b-icon>
                                  </td>

                                  <td class='table-td'>
                                    <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                                  </td>

                                  <td colspan='2' class='table-td'>
                                    O agente foi classificado, porém não apresentou enquadramento para a ACGIH.
                                  </td>
                                </tr>
                              </template>

                              <template
                                v-else-if="model.getInteractions(legalSearch) === 'one-interaction' || model.getInteractions(legalSearch) === 'none-interaction'">
                                <tr :key="`${legalSearch.legalSearchId}-${roleProductLegalConsultation.product._id}-${roleItem._id}-chem-interaction`">
                                  <td class='table-td'>
                                    <b-icon
                                      @click='showModalSuggestionForImprovement(legalSearch)'
                                      class='cursor-pointer'
                                      font-scale='1.5'
                                      icon='pencil-square'
                                      color='#262626'
                                    >
                                    </b-icon>
                                  </td>

                                  <td class='table-td'>
                                    <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                                    <a
                                      href='#'
                                      v-b-tooltip.lefttop.hover.html
                                      :title="model.getValue('interactions', legalSearch, 1)"
                                      v-if="model.getValue('interactions', legalSearch, 1) != '-'"
                                      @click='displayInteractions(legalSearch)'
                                    >
                                      <span style='' class='d-flex justify-content-center'>
                                        Especificações
                                        <b-icon
                                          class='ml-1'
                                          font-scale='1.2'
                                          icon='info-circle-fill'
                                          variant='info'
                                        >
                                        </b-icon>
                                      </span>
                                    </a>
                                  </td>

                                  <td class='table-td  '>
                                    <section class='pl-4'>
                                      <ul style='text-align: left' class='limits'>
                                        <li>
                                          <strong>8h ou TWA: </strong>
                                          <span class=''>{{ getInformationTwa(legalSearch) }}</span>
                                        </li>
                                        <li>
                                          <strong>15 min ou STEL: </strong>
                                          <span class=''>{{ getInformationStel(legalSearch) }}</span>
                                        </li>
                                      </ul>
                                    </section>
                                  </td>

                                  <td class='table-td'>
                                    <section class='pl-4'>
                                      <ul style='text-align: left' class='limits'>
                                        <li>
                                          <strong>ACGIH: </strong>
                                          <span class=''>{{ formatNotationsBaseDoTlv(legalSearch) }}</span>
                                        </li>
                                      </ul>
                                    </section>
                                  </td>
                                </tr>
                              </template>

                              <template v-else-if="model.getInteractions(legalSearch) === 'select-interaction'">
                                <tr :key="`${legalSearch.legalSearchId}-${roleProductLegalConsultation.product._id}-${roleItem._id}-chem-select-interaction`">
                                  <td class='table-td'>
                                    <b-icon
                                      @click='showModalSuggestionForImprovement(legalSearch)'
                                      class='cursor-pointer'
                                      font-scale='1.5'
                                      icon='pencil-square'
                                      color='#262626'
                                    >
                                    </b-icon>
                                  </td>

                                  <td class='table-td'>
                                    <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                                  </td>

                                  <td colspan='2' class='table-td  '>
                                    <a href='#' @click='displayInteractions(legalSearch)'>
                                      Agente necessita de determinação de fração ou forma de
                                      exposição, selecione aqui
                                    </a>
                                  </td>
                                </tr>
                              </template>
                            </template>
                            </tbody>
                          </table>
                        </section>
                      </section>
                    </section>

                    <!-- ===== RISCOS FÍSICOS ===== -->
                    <section v-if="getRolesLegalsearches(roleItem, 'fisico')" class='risk-physical d-flex align-items-center justify-content-between px-3 py-2'>
                      <strong class='risk-text'>Riscos Físicos</strong>
                      <button class='btn-expand-collapse-navy-blue' :class="roleItem.physicalRiskOpen ? '' : 'pulse-global'" @click="toggleRoleRiskOpen(roleItem, 'physicalRiskOpen')">
                        {{ roleItem.physicalRiskOpen ? 'Recolher informações' : 'Expandir informações' }}
                      </button>
                    </section>

                    <table v-if="roleItem.physicalRiskOpen && getRolesLegalsearches(roleItem, 'fisico')" class='w-100 text-center transition' style='margin-top: -2px;'>
                      <thead class='py-3'>
                      <tr class='headerTable'>
                        <th class='width-10-percent'>Ações</th>
                        <th class='width-20-percent'>CAS: Agente</th>
                        <th class='width-30-percent'>Limites (referência)</th>
                        <th class='width-40-percent'>Relevância toxicológica (referência)</th>
                      </tr>
                      </thead>
                      <tbody>
                      <template v-for="legalSearch in getAgentsByRisk(roleItem, 'fisico')">
                        <template v-if='!legalSearch.acgih'>
                          <tr :key="`${legalSearch.cas}-${legalSearch.index}-${roleItem._id}-phys-not-acgih`">
                            <td class='table-td'>
                              <b-icon
                                @click='showModalSuggestionForImprovement(legalSearch)'
                                class='cursor-pointer'
                                font-scale='1.5'
                                icon='pencil-square'
                                color='#262626'
                              >
                              </b-icon>
                            </td>

                            <td class='table-td'>
                              <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                            </td>

                            <td colspan='2' class='table-td'>
                              O agente foi classificado, porém não apresentou enquadramento para a ACGIH.
                            </td>
                          </tr>
                        </template>

                        <template
                          v-else-if="model.getInteractions(legalSearch) === 'one-interaction' || model.getInteractions(legalSearch) === 'none-interaction'">
                          <tr :key="`${legalSearch.legalSearchId}-${roleItem._id}-phys-interaction`">
                            <td class='table-td'>
                              <b-icon
                                @click='showModalSuggestionForImprovement(legalSearch)'
                                class='cursor-pointer'
                                font-scale='1.5'
                                icon='pencil-square'
                                color='#262626'
                              >
                              </b-icon>
                            </td>

                            <td class='table-td'>
                              <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                              <a
                                href='#'
                                v-b-tooltip.lefttop.hover.html
                                :title="model.getValue('interactions', legalSearch, 1)"
                                v-if="model.getValue('interactions', legalSearch, 1) != '-'"
                                @click='displayInteractions(legalSearch)'
                              >
                                <span style='' class='d-flex justify-content-center'>
                                  Especificações
                                  <b-icon
                                    class='ml-1'
                                    font-scale='1.2'
                                    icon='info-circle-fill'
                                    variant='info'
                                  >
                                  </b-icon>
                                </span>
                              </a>
                            </td>

                            <td class='table-td  '>
                              <section class='pl-4'>
                                <ul style='text-align: left' class='limits'>
                                  <li>
                                    <strong>8h ou TWA: </strong>
                                    <span class=''>{{ getInformationTwa(legalSearch) }}</span>
                                  </li>
                                  <li>
                                    <strong>15 min ou STEL: </strong>
                                    <span class=''>{{ getInformationStel(legalSearch) }}</span>
                                  </li>
                                </ul>
                              </section>
                            </td>

                            <td class='table-td'>
                              <section class='pl-4'>
                                <ul style='text-align: left' class='limits'>
                                  <li>
                                    <strong>ACGIH: </strong>
                                    <span class=''>{{ formatNotationsBaseDoTlv(legalSearch) }}</span>
                                  </li>
                                </ul>
                              </section>
                            </td>
                          </tr>
                        </template>

                        <template v-else-if="model.getInteractions(legalSearch) === 'select-interaction'">
                          <tr :key="`${legalSearch.legalSearchId}-${roleItem._id}-phys-select-interaction`">
                            <td class='table-td'>
                              <b-icon
                                @click='showModalSuggestionForImprovement(legalSearch)'
                                class='cursor-pointer'
                                font-scale='1.5'
                                icon='pencil-square'
                                color='#262626'
                              >
                              </b-icon>
                            </td>

                            <td class='table-td'>
                              <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                            </td>

                            <td colspan='2' class='table-td  '>
                              <a href='#' @click='displayInteractions(legalSearch)'>
                                Agente necessita de determinação de fração ou forma de
                                exposição, selecione aqui
                              </a>
                            </td>
                          </tr>
                        </template>
                      </template>
                      </tbody>
                    </table>

                    <!-- ===== RISCOS BIOLÓGICOS ===== -->
                    <section v-if="getRolesLegalsearches(roleItem, 'biologico')" class='risk-biological d-flex align-items-center justify-content-between px-3 py-2'>
                      <strong class='risk-text'>Riscos Biológicos</strong>
                      <button class='btn-expand-collapse-navy-blue' :class="roleItem.biologicalRiskOpen ? '' : 'pulse-global'" @click="toggleRoleRiskOpen(roleItem, 'biologicalRiskOpen')">
                        {{ roleItem.biologicalRiskOpen ? 'Recolher informações' : 'Expandir informações' }}
                      </button>
                    </section>

                    <table v-if="roleItem.biologicalRiskOpen && getRolesLegalsearches(roleItem, 'biologico')" class='w-100 text-center transition' style='margin-top: -2px;'>
                      <thead class='py-3'>
                      <tr class='headerTable'>
                        <th class='width-10-percent'>Ações</th>
                        <th class='width-20-percent'>CAS: Agente</th>
                        <th class='width-30-percent'>Limites (referência)</th>
                        <th class='width-40-percent'>Relevância toxicológica (referência)</th>
                      </tr>
                      </thead>
                      <tbody>
                      <template v-for="legalSearch in getAgentsByRisk(roleItem, 'biologico')">
                        <template v-if='!legalSearch.acgih'>
                          <tr :key="`${legalSearch.cas}-${legalSearch.index}-${roleItem._id}-bio-not-acgih`">
                            <td class='table-td'>
                              <b-icon
                                @click='showModalSuggestionForImprovement(legalSearch)'
                                class='cursor-pointer'
                                font-scale='1.5'
                                icon='pencil-square'
                                color='#262626'
                              >
                              </b-icon>
                            </td>

                            <td class='table-td'>
                              <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                            </td>

                            <td colspan='2' class='table-td'>
                              O agente foi classificado, porém não apresentou enquadramento para a ACGIH.
                            </td>
                          </tr>
                        </template>

                        <template
                          v-else-if="model.getInteractions(legalSearch) === 'one-interaction' || model.getInteractions(legalSearch) === 'none-interaction'">
                          <tr :key="`${legalSearch.legalSearchId}-${roleItem._id}-bio-interaction`">
                            <td class='table-td'>
                              <b-icon
                                @click='showModalSuggestionForImprovement(legalSearch)'
                                class='cursor-pointer'
                                font-scale='1.5'
                                icon='pencil-square'
                                color='#262626'
                              >
                              </b-icon>
                            </td>

                            <td class='table-td'>
                              <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                              <a
                                href='#'
                                v-b-tooltip.lefttop.hover.html
                                :title="model.getValue('interactions', legalSearch, 1)"
                                v-if="model.getValue('interactions', legalSearch, 1) != '-'"
                                @click='displayInteractions(legalSearch)'
                              >
                                <span style='' class='d-flex justify-content-center'>
                                  Especificações
                                  <b-icon
                                    class='ml-1'
                                    font-scale='1.2'
                                    icon='info-circle-fill'
                                    variant='info'
                                  >
                                  </b-icon>
                                </span>
                              </a>
                            </td>

                            <td class='table-td  '>
                              <section class='pl-4'>
                                <ul style='text-align: left' class='limits'>
                                  <li>
                                    <strong>8h ou TWA: </strong>
                                    <span class=''>{{ getInformationTwa(legalSearch) }}</span>
                                  </li>
                                  <li>
                                    <strong>15 min ou STEL: </strong>
                                    <span class=''>{{ getInformationStel(legalSearch) }}</span>
                                  </li>
                                </ul>
                              </section>
                            </td>

                            <td class='table-td'>
                              <section class='pl-4'>
                                <ul style='text-align: left' class='limits'>
                                  <li>
                                    <strong>ACGIH: </strong>
                                    <span class=''>{{ formatNotationsBaseDoTlv(legalSearch) }}</span>
                                  </li>
                                </ul>
                              </section>
                            </td>
                          </tr>
                        </template>

                        <template v-else-if="model.getInteractions(legalSearch) === 'select-interaction'">
                          <tr :key="`${legalSearch.legalSearchId}-${roleItem._id}-bio-select-interaction`">
                            <td class='table-td'>
                              <b-icon
                                @click='showModalSuggestionForImprovement(legalSearch)'
                                class='cursor-pointer'
                                font-scale='1.5'
                                icon='pencil-square'
                                color='#262626'
                              >
                              </b-icon>
                            </td>

                            <td class='table-td'>
                              <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                            </td>

                            <td colspan='2' class='table-td  '>
                              <a href='#' @click='displayInteractions(legalSearch)'>
                                Agente necessita de determinação de fração ou forma de
                                exposição, selecione aqui
                              </a>
                            </td>
                          </tr>
                        </template>
                      </template>
                      </tbody>
                    </table>
                  </section>
                </section>
          </section>
        </section>

        <section v-show="productsLegalConsultation && productsLegalConsultation.length > 0">
          <hr/>
        </section>

        <section
          v-show="productsLegalConsultation && productsLegalConsultation.length > 0"
          class="my-3"
        >
          <section class='risk-chemical d-flex align-items-center justify-content-center pt-3 pb-1 text-center w-100'>
            <h6><strong>Agentes pesquisados vinculados a produtos e sem vínculo com cargos.</strong></h6>
          </section>

          <section class='risk-chemical d-flex align-items-center justify-content-between px-3 py-2'>
            <section>
              <strong class='risk-text'>Riscos Químicos</strong>
            </section>

            <section>
              <button class='btn-expand-collapse-navy-blue' :class="userPreferences && userPreferences.tabPreventionistLimitsChemicalRiskOpenAgentsLinkedProductWithoutRole ? '' : 'pulse-global'" @click="toggleChemicalExpanded('tabPreventionistLimitsChemicalRiskOpenAgentsLinkedProductWithoutRole')">
                {{ userPreferences && userPreferences.tabPreventionistLimitsChemicalRiskOpenAgentsLinkedProductWithoutRole ? 'Recolher informações' : 'Expandir informações' }}
              </button>
            </section>
          </section>

          <section
            v-if="userPreferences && userPreferences.tabPreventionistLimitsChemicalRiskOpenAgentsLinkedProductWithoutRole"
            class='transition margin-left-25'
          >
            <section
              v-for='item in productsLegalConsultation'
              :key='item._id'
            >
              <section :id='item._id'>
                <section class='product'>
                  <section
                    class='product d-flex align-items-center justify-content-between'
                    style='background: #DADADA'
                  >
                    <section class='d-flex align-items-center justify-content-start h-100 ml-3'>
                      <img
                        :src="require('@/assets/images/product-chemical.svg')"
                        width="32"
                        height="28"
                        alt="Produto químico"
                      />

                      <span class='name ml-2'>
                        Produto: {{ item.name }}
                      </span>
                    </section>

                    <section class='d-flex align-items-center justify-content-end mr-3'>
                      <button class='btn-expand-collapse-navy-blue' :class="item.open ? '' : 'pulse-global'" @click='toggleProductLegalConsultationOpen(item)'>
                        {{ item.open ? 'Recolher informações' : 'Expandir informações' }}
                      </button>
                    </section>
                  </section>

                  <table v-if='item.open' class="w-100 text-center" style="margin-top: -2px;">
                    <thead class="py-3">
                    <tr class="headerTable">
                      <th class="width-10-percent">Ações</th>
                      <th class="width-20-percent">CAS: Agente</th>
                      <th class="width-30-percent">Limites (referência)</th>
                      <th class="width-40-percent">Relevância toxicológica (referência)</th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for='legalSearch in item.legalSearches'>
                      <template v-if="!legalSearch.acgih">
                        <tr :key="`${legalSearch.cas}-${legalSearch.index}-${item._id}-wr-not-acgih`">
                          <td class="table-td">
                            <b-icon
                              @click="showModalSuggestionForImprovement(legalSearch)"
                              class='cursor-pointer'
                              font-scale='1.5'
                              icon='pencil-square'
                              color='#262626'
                            >
                            </b-icon>
                          </td>

                          <td class="table-td">
                            <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                          </td>

                          <td colspan="2" class="table-td">
                            O agente foi classificado, porém não apresentou enquadramento para a ACGIH.
                          </td>
                        </tr>
                      </template>

                      <template
                        v-else-if="model.getInteractions(legalSearch) === 'one-interaction' || model.getInteractions(legalSearch) === 'none-interaction'">
                        <tr :key="`${legalSearch.legalSearchId}-${item._id}-wr-interaction`">
                          <td class="table-td">
                            <b-icon
                              @click="showModalSuggestionForImprovement(legalSearch)"
                              class='cursor-pointer'
                              font-scale='1.5'
                              icon='pencil-square'
                              color='#262626'
                            >
                            </b-icon>
                          </td>

                          <td class="table-td">
                            <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                            <a
                              href="#"
                              v-b-tooltip.lefttop.hover.html
                              :title="model.getValue('interactions', legalSearch, 1)"
                              v-if="model.getValue('interactions', legalSearch, 1) != '-'"
                              @click="displayInteractions(legalSearch)"
                            >
                              <span style='' class='d-flex justify-content-center'>
                                Especificações
                                <b-icon
                                  class='ml-1'
                                  font-scale="1.2"
                                  icon="info-circle-fill"
                                  variant="info"
                                >
                                </b-icon>
                              </span>
                            </a>
                          </td>

                          <td class="table-td  ">
                            <section class="pl-4">
                              <ul style="text-align: left" class="limits">
                                <li>
                                  <strong>8h ou TWA: </strong>
                                  <span class="">{{ getInformationTwa(legalSearch) }}</span>
                                </li>
                                <li>
                                  <strong>15 min ou STEL: </strong>
                                  <span class="">{{ getInformationStel(legalSearch) }}</span>
                                </li>
                              </ul>
                            </section>
                          </td>

                          <td class="table-td">
                            <section class="pl-4">
                              <ul style="text-align: left" class="limits">
                                <li>
                                  <strong>ACGIH: </strong>
                                  <span class="">{{ formatNotationsBaseDoTlv(legalSearch) }}</span>
                                </li>
                              </ul>
                            </section>
                          </td>
                        </tr>
                      </template>

                      <template v-else-if="model.getInteractions(legalSearch) === 'select-interaction'">
                        <tr :key="`${legalSearch.legalSearchId}-${item._id}-wr-select-interaction`">
                          <td class="table-td">
                            <b-icon
                              @click="showModalSuggestionForImprovement(legalSearch)"
                              class='cursor-pointer'
                              font-scale='1.5'
                              icon='pencil-square'
                              color='#262626'
                            >
                            </b-icon>
                          </td>

                          <td class="table-td">
                            <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                          </td>

                          <td colspan="2" class="table-td  ">
                            <a href="#" @click="displayInteractions(legalSearch)">
                              Agente necessita de determinação de fração ou forma de
                              exposição, selecione aqui
                            </a>
                          </td>
                        </tr>
                      </template>
                    </template>
                    </tbody>
                  </table>
                </section>
              </section>
            </section>
          </section>
        </section>

        <section  v-show="agentsWithoutProduct && agentsWithoutProduct.length > 0">
          <hr/>
        </section>

        <section
          v-show="agentsWithoutProduct && agentsWithoutProduct.length > 0"
          v-for='agentWithoutProduct in agentsWithoutProduct'
          :key="agentWithoutProduct._id"
          class="mt-1"
        >
          <section v-if="agentWithoutProduct.riskType === 'quimico'">
            <section class='risk-chemical d-flex align-items-center justify-content-center pt-3 text-center w-100'>
              <h6><strong>Agentes pesquisados sem vínculo de produto ou cargo.</strong></h6>
            </section>

            <section class='risk-chemical d-flex align-items-center justify-content-between px-3 py-2'>
              <section>
                <strong class='risk-text'>Riscos Químicos</strong>
              </section>

              <section>
                <button class='btn-expand-collapse-navy-blue' :class="userPreferences && userPreferences.tabPreventionistLimitsChemicalRiskOpenAgentsWithoutProductAffiliation ? '' : 'pulse-global'" @click="toggleChemicalExpanded('tabPreventionistLimitsChemicalRiskOpenAgentsWithoutProductAffiliation')">
                  {{ userPreferences && userPreferences.tabPreventionistLimitsChemicalRiskOpenAgentsWithoutProductAffiliation ? 'Recolher informações' : 'Expandir informações' }}
                </button>
              </section>
            </section>

            <table v-if="userPreferences && userPreferences.tabPreventionistLimitsChemicalRiskOpenAgentsWithoutProductAffiliation" class="w-100 text-center" style="margin-top: -2px;">
              <thead class="py-3">
              <tr class="headerTable">
                <th class="width-10-percent">Ações</th>
                <th class="width-20-percent">CAS: Agente</th>
                <th class="width-30-percent">Limites (referência)</th>
                <th class="width-40-percent">Relevância toxicológica (referência)</th>
              </tr>
              </thead>
              <tbody>
              <template v-for='legalSearch in agentWithoutProduct.legalSearches'>
                <template v-if="!legalSearch.acgih">
                  <tr :key="`${legalSearch.cas}-${agentWithoutProduct._id}-chemical-not-acgih`">
                    <td class="table-td">
                      <b-icon
                        @click="showModalSuggestionForImprovement(legalSearch)"
                        class='cursor-pointer'
                        font-scale='1.5'
                        icon='pencil-square'
                        color='#262626'
                      >
                      </b-icon>
                    </td>

                    <td class="table-td">
                      <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                    </td>

                    <td colspan="2" class="table-td">
                      O agente foi classificado, porém não apresentou enquadramento para a ACGIH.
                    </td>
                  </tr>
                </template>

                <template
                  v-else-if="model.getInteractions(legalSearch) === 'one-interaction' || model.getInteractions(legalSearch) === 'none-interaction'">
                  <tr :key="`${legalSearch.legalSearchId}-${agentWithoutProduct._id}-chemical-one-none-interaction`">
                    <td class="table-td">
                      <b-icon
                        @click="showModalSuggestionForImprovement(legalSearch)"
                        class='cursor-pointer'
                        font-scale='1.5'
                        icon='pencil-square'
                        color='#262626'
                      >
                      </b-icon>
                    </td>

                    <td class="table-td">
                      <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                      <a
                        href="#"
                        v-b-tooltip.lefttop.hover.html
                        :title="model.getValue('interactions', legalSearch, 1)"
                        v-if="model.getValue('interactions', legalSearch, 1) != '-'"
                        @click="displayInteractions(legalSearch)"
                      >
                        <span style='' class='d-flex justify-content-center'>
                          Especificações
                          <b-icon
                            class='ml-1'
                            font-scale="1.2"
                            icon="info-circle-fill"
                            variant="info"
                          >
                          </b-icon>
                        </span>
                      </a>
                    </td>

                    <td class="table-td  ">
                      <section class="pl-4">
                        <ul style="text-align: left" class="limits">
                          <li>
                            <strong>8h ou TWA: </strong>
                            <span class="">{{ getInformationTwa(legalSearch) }}</span>
                          </li>
                          <li>
                            <strong>15 min ou STEL: </strong>
                            <span class="">{{ getInformationStel(legalSearch) }}</span>
                          </li>
                        </ul>
                      </section>
                    </td>

                    <td class="table-td">
                      <section class="pl-4">
                        <ul style="text-align: left" class="limits">
                          <li>
                            <strong>ACGIH: </strong>
                            <span class="">{{ formatNotationsBaseDoTlv(legalSearch) }}</span>
                          </li>
                        </ul>
                      </section>
                    </td>
                  </tr>
                </template>

                <template v-else-if="model.getInteractions(legalSearch) === 'select-interaction'">
                  <tr :key="`${legalSearch.legalSearchId}-${agentWithoutProduct._id}-chemical-select-interaction`">
                    <td class="table-td">
                      <b-icon
                        @click="showModalSuggestionForImprovement(legalSearch)"
                        class='cursor-pointer'
                        font-scale='1.5'
                        icon='pencil-square'
                        color='#262626'
                      >
                      </b-icon>
                    </td>

                    <td class="table-td">
                      <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                    </td>

                    <td colspan="2" class="table-td  ">
                      <a href="#" @click="displayInteractions(legalSearch)">
                        Agente necessita de determinação de fração ou forma de
                        exposição, selecione aqui
                      </a>
                    </td>
                  </tr>
                </template>
              </template>
              </tbody>
            </table>
          </section>

          <section v-if="agentWithoutProduct.riskType === 'fisico'">
            <section class='risk-physical d-flex align-items-center justify-content-center pt-3 pb-1 text-center w-100'>
              <h6><strong>Agentes pesquisados sem vínculo de produto ou cargo.</strong></h6>
            </section>

            <section class='risk-physical d-flex align-items-center justify-content-between px-3 py-2'>
              <section>
                <strong class='risk-text'>Riscos Físicos</strong>
              </section>

              <section>
                <button class='btn-expand-collapse-navy-blue' :class="userPreferences && userPreferences.tabPreventionistLimitsPhysicalRiskOpenAgentsWithoutProductAffiliation ? '' : 'pulse-global'" @click="toggleChemicalExpanded('tabPreventionistLimitsPhysicalRiskOpenAgentsWithoutProductAffiliation')">
                  {{ userPreferences && userPreferences.tabPreventionistLimitsPhysicalRiskOpenAgentsWithoutProductAffiliation ? 'Recolher informações' : 'Expandir informações' }}
                </button>
              </section>
            </section>

            <table v-if="userPreferences && userPreferences.tabPreventionistLimitsPhysicalRiskOpenAgentsWithoutProductAffiliation" class="w-100 text-center" style="margin-top: -2px;">
              <thead class="py-3">
              <tr class="headerTable">
                <th class="width-10-percent">Ações</th>
                <th class="width-20-percent">CAS: Agente</th>
                <th class="width-30-percent">Limites (referência)</th>
                <th class="width-40-percent">Relevância toxicológica (referência)</th>
              </tr>
              </thead>
              <tbody>
              <template v-for='legalSearch in agentWithoutProduct.legalSearches'>
                <template v-if="!legalSearch.acgih">
                  <tr :key="`${legalSearch.cas}-${agentWithoutProduct._id}-physical-not-acgih`">
                    <td class="table-td">
                      <b-icon
                        @click="showModalSuggestionForImprovement(legalSearch)"
                        class='cursor-pointer'
                        font-scale='1.5'
                        icon='pencil-square'
                        color='#262626'
                      >
                      </b-icon>
                    </td>

                    <td class="table-td">
                      <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                    </td>

                    <td colspan="2" class="table-td">
                      O agente foi classificado, porém não apresentou enquadramento para a ACGIH.
                    </td>
                  </tr>
                </template>

                <template
                  v-else-if="model.getInteractions(legalSearch) === 'one-interaction' || model.getInteractions(legalSearch) === 'none-interaction'">
                  <tr :key="`${legalSearch.legalSearchId}-${agentWithoutProduct._id}-physical-one-none-interaction`">
                    <td class="table-td">
                      <b-icon
                        @click="showModalSuggestionForImprovement(legalSearch)"
                        class='cursor-pointer'
                        font-scale='1.5'
                        icon='pencil-square'
                        color='#262626'
                      >
                      </b-icon>
                    </td>

                    <td class="table-td">
                      <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                      <a
                        href="#"
                        v-b-tooltip.lefttop.hover.html
                        :title="model.getValue('interactions', legalSearch, 1)"
                        v-if="model.getValue('interactions', legalSearch, 1) != '-'"
                        @click="displayInteractions(legalSearch)"
                      >
                        <span style='' class='d-flex justify-content-center'>
                          Especificações
                          <b-icon
                            class='ml-1'
                            font-scale="1.2"
                            icon="info-circle-fill"
                            variant="info"
                          >
                          </b-icon>
                        </span>
                      </a>
                    </td>

                    <td class="table-td  ">
                      <section class="pl-4">
                        <ul style="text-align: left" class="limits">
                          <li>
                            <strong>8h ou TWA: </strong>
                            <span class="">{{ getInformationTwa(legalSearch) }}</span>
                          </li>
                          <li>
                            <strong>15 min ou STEL: </strong>
                            <span class="">{{ getInformationStel(legalSearch) }}</span>
                          </li>
                        </ul>
                      </section>
                    </td>

                    <td class="table-td">
                      <section class="pl-4">
                        <ul style="text-align: left" class="limits">
                          <li>
                            <strong>ACGIH: </strong>
                            <span class="">{{ formatNotationsBaseDoTlv(legalSearch) }}</span>
                          </li>
                        </ul>
                      </section>
                    </td>
                  </tr>
                </template>

                <template v-else-if="model.getInteractions(legalSearch) === 'select-interaction'">
                  <tr :key="`${legalSearch.legalSearchId}-${agentWithoutProduct._id}-physical-select-interaction`">
                    <td class="table-td">
                      <b-icon
                        @click="showModalSuggestionForImprovement(legalSearch)"
                        class='cursor-pointer'
                        font-scale='1.5'
                        icon='pencil-square'
                        color='#262626'
                      >
                      </b-icon>
                    </td>

                    <td class="table-td">
                      <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                    </td>

                    <td colspan="2" class="table-td  ">
                      <a href="#" @click="displayInteractions(legalSearch)">
                        Agente necessita de determinação de fração ou forma de
                        exposição, selecione aqui
                      </a>
                    </td>
                  </tr>
                </template>
              </template>
              </tbody>
            </table>
          </section>

          <section v-if="agentWithoutProduct.riskType === 'biologico'">
            <section class='risk-biological d-flex align-items-center justify-content-center pt-3 pb-1 text-center w-100'>
              <h6><strong>Agentes pesquisados sem vínculo de produto ou cargo.</strong></h6>
            </section>

            <section class='risk-biological d-flex align-items-center justify-content-between px-3 py-2'>
              <section>
                <strong class='risk-text'>Riscos Biológicos</strong>
              </section>

              <section>
                <button class='btn-expand-collapse-navy-blue' :class="userPreferences && userPreferences.tabPreventionistLimitsBiologicalRiskOpenAgentsWithoutProductAffiliation ? '' : 'pulse-global'" @click="toggleChemicalExpanded('tabPreventionistLimitsBiologicalRiskOpenAgentsWithoutProductAffiliation')">
                  {{ userPreferences && userPreferences.tabPreventionistLimitsBiologicalRiskOpenAgentsWithoutProductAffiliation ? 'Recolher informações' : 'Expandir informações' }}
                </button>
              </section>
            </section>

            <table v-if="userPreferences && userPreferences.tabPreventionistLimitsBiologicalRiskOpenAgentsWithoutProductAffiliation" class="w-100 text-center" style="margin-top: -2px;">
              <thead class="py-3">
              <tr class="headerTable">
                <th class="width-10-percent">Ações</th>
                <th class="width-20-percent">CAS: Agente</th>
                <th class="width-30-percent">Limites (referência)</th>
                <th class="width-40-percent">Relevância toxicológica (referência)</th>
              </tr>
              </thead>
              <tbody>
              <template v-for='legalSearch in agentWithoutProduct.legalSearches'>
                <template v-if="!legalSearch.acgih">
                  <tr :key="`${legalSearch.cas}-${agentWithoutProduct._id}-biological-not-acgih`">
                    <td class="table-td">
                      <b-icon
                        @click="showModalSuggestionForImprovement(legalSearch)"
                        class='cursor-pointer'
                        font-scale='1.5'
                        icon='pencil-square'
                        color='#262626'
                      >
                      </b-icon>
                    </td>

                    <td class="table-td">
                      <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                    </td>

                    <td colspan="2" class="table-td">
                      O agente foi classificado, porém não apresentou enquadramento para a ACGIH.
                    </td>
                  </tr>
                </template>

                <template
                  v-else-if="model.getInteractions(legalSearch) === 'one-interaction' || model.getInteractions(legalSearch) === 'none-interaction'">
                  <tr :key="`${legalSearch.legalSearchId}-${agentWithoutProduct._id}-biological-one-none-interaction`">
                    <td class="table-td">
                      <b-icon
                        @click="showModalSuggestionForImprovement(legalSearch)"
                        class='cursor-pointer'
                        font-scale='1.5'
                        icon='pencil-square'
                        color='#262626'
                      >
                      </b-icon>
                    </td>

                    <td class="table-td">
                      <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                      <a
                        href="#"
                        v-b-tooltip.lefttop.hover.html
                        :title="model.getValue('interactions', legalSearch, 1)"
                        v-if="model.getValue('interactions', legalSearch, 1) != '-'"
                        @click="displayInteractions(legalSearch)"
                      >
                        <span style='' class='d-flex justify-content-center'>
                          Especificações
                          <b-icon
                            class='ml-1'
                            font-scale="1.2"
                            icon="info-circle-fill"
                            variant="info"
                          >
                          </b-icon>
                        </span>
                      </a>
                    </td>

                    <td class="table-td  ">
                      <section class="pl-4">
                        <ul style="text-align: left" class="limits">
                          <li>
                            <strong>8h ou TWA: </strong>
                            <span class="">{{ getInformationTwa(legalSearch) }}</span>
                          </li>
                          <li>
                            <strong>15 min ou STEL: </strong>
                            <span class="">{{ getInformationStel(legalSearch) }}</span>
                          </li>
                        </ul>
                      </section>
                    </td>

                    <td class="table-td">
                      <section class="pl-4">
                        <ul style="text-align: left" class="limits">
                          <li>
                            <strong>ACGIH: </strong>
                            <span class="">{{ formatNotationsBaseDoTlv(legalSearch) }}</span>
                          </li>
                        </ul>
                      </section>
                    </td>
                  </tr>
                </template>

                <template v-else-if="model.getInteractions(legalSearch) === 'select-interaction'">
                  <tr :key="`${legalSearch.legalSearchId}-${agentWithoutProduct._id}-biological-select-interaction`">
                    <td class="table-td">
                      <b-icon
                        @click="showModalSuggestionForImprovement(legalSearch)"
                        class='cursor-pointer'
                        font-scale='1.5'
                        icon='pencil-square'
                        color='#262626'
                      >
                      </b-icon>
                    </td>

                    <td class="table-td">
                      <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                    </td>

                    <td colspan="2" class="table-td  ">
                      <a href="#" @click="displayInteractions(legalSearch)">
                        Agente necessita de determinação de fração ou forma de
                        exposição, selecione aqui
                      </a>
                    </td>
                  </tr>
                </template>
              </template>
              </tbody>
            </table>
          </section>
        </section>
      </section>

      <section v-else>
        <section class="">
          <table class="w-100 text-center" style="margin-top: -2px;">
            <thead class="py-3">
            <tr class="headerTable">
              <th class="width-10-percent">
                Ações
              </th>
              <th class="width-20-percent">
                CAS: Agente
              </th>
              <th class="width-30-percent">
                Limites (referência)
              </th>
              <th class="width-40-percent">
                Relevância toxicológica (referência)
              </th>
            </tr>
            </thead>
            <tbody>
            <template v-for='legalSearch in summary'>
              <template v-if="!legalSearch.acgih">
                <tr :key="`${legalSearch.cas}-${legalSearch.index}-not-acgih`">
                  <td class="table-td">
                    <b-icon
                      @click="showModalSuggestionForImprovement(legalSearch)"
                      class='cursor-pointer'
                      font-scale='1.5'
                      icon='pencil-square'
                      color='#262626'
                    >
                    </b-icon>
                  </td>

                  <td class="table-td">
                    <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                  </td>

                  <td colspan="2" class="table-td">
                    O agente foi classificado, porém não apresentou enquadramento para a ACGIH.
                  </td>
                </tr>
              </template>

              <template
                v-else-if="model.getInteractions(legalSearch) === 'one-interaction' || model.getInteractions(legalSearch) === 'none-interaction'">
                <tr :key="`${legalSearch.cas}-${legalSearch.index}-one-interaction-none-interaction`">
                  <td class="table-td">
                    <b-icon
                      @click="showModalSuggestionForImprovement(legalSearch)"
                      class='cursor-pointer'
                      font-scale='1.5'
                      icon='pencil-square'
                      color='#262626'
                    >
                    </b-icon>
                  </td>

                  <td class="table-td">
                    <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                    <a
                      href="#"
                      v-b-tooltip.lefttop.hover.html
                      :title="model.getValue('interactions', legalSearch, 1)"
                      v-if="model.getValue('interactions', legalSearch, 1) != '-'"
                      @click="displayInteractions(legalSearch)"
                    >
                        <span style='' class='d-flex justify-content-center'>
                          Especificações
                          <b-icon
                            class='ml-1'
                            font-scale="1.2"
                            icon="info-circle-fill"
                            variant="info"
                          >
                          </b-icon>
                        </span>
                    </a>
                  </td>

                  <td class="table-td  ">
                    <section class="pl-4">
                      <ul style="text-align: left" class="limits">
                        <li>
                          <strong>8h ou TWA: </strong>
                          <span class="">{{ getInformationTwa(legalSearch) }}</span>
                        </li>
                        <li>
                          <strong>15 min ou STEL: </strong>
                          <span class="">{{ getInformationStel(legalSearch) }}</span>
                        </li>
                      </ul>
                    </section>
                  </td>

                  <td class="table-td">
                    <section class="pl-4">
                      <ul style="text-align: left" class="limits">
                        <li>
                          <strong>ACGIH: </strong>
                          <span class="">{{ formatNotationsBaseDoTlv(legalSearch) }}</span>
                        </li>
                        <!--<li>
                          <strong>GESTIS: </strong>
                          <span class="">{{ formatNotationsBaseDoTlv(legalSearch) }}</span>
                        </li>-->
                      </ul>
                    </section>
                  </td>
                </tr>
              </template>

              <template v-else-if="model.getInteractions(legalSearch) === 'select-interaction'">
                <tr :key="`${legalSearch.cas}-${legalSearch.index}-one-interaction-none-interaction`">
                  <td class="table-td">
                    <b-icon
                      @click="showModalSuggestionForImprovement(legalSearch)"
                      class='cursor-pointer'
                      font-scale='1.5'
                      icon='pencil-square'
                      color='#262626'
                    >
                    </b-icon>
                  </td>

                  <td class="table-td">
                    <span class='cas-agent word-break'>{{ model.getsearchId(legalSearch) }}</span>
                  </td>

                  <td colspan="2" class="table-td  ">
                    <a href="#" @click="displayInteractions(legalSearch)">
                      Agente necessita de determinação de fração ou forma de
                      exposição, selecione aqui
                    </a>
                  </td>
                </tr>
              </template>
            </template>
            </tbody>
          </table>
        </section>
      </section>

      <template v-slot:overlay>
        <div class='text-center loading-spinner'>
          <b-spinner
            style='width: 2.5rem; height: 2.5rem'
            variant='primary'
            label='Large Spinner'
          ></b-spinner>
          <h5 class='text-primary'><strong>Buscando cargos, produtos e agentes...</strong></h5>
        </div>
      </template>
    </b-overlay>
  </section>
</template>

<script>

import TabButtons from '@/components/LegalSearch/components/TabButtons.vue'
import { mapActions, mapGetters } from 'vuex'
import Acigh from '@/models/Acgih'
import AcighModel from '@/components/LegalSearch/AcighModal.vue'
import SuggestionForImprovement
  from '@/components/LegalSearch/PreventionistLimits/components/SuggestionForImprovement.vue'
import AcceptInformationTab from '@/components/LegalSearch/PreventionistLimits/components/AcceptInformationTab.vue'
import AgentPercentage from '@/components/LegalSearch/Modal/AgentPercentage.vue'
import ModalConfirmAction from '@/components/ModalConfirmAction.vue'
import ArchivedRoles from '@/components/LegalSearch/Gro/components/ArchivedRoles.vue'
import eventBus from '@/utils/eventBus'

export default {
  name: 'PreventionistLimits',
  components: { AgentPercentage, AcceptInformationTab, SuggestionForImprovement, AcighModel, TabButtons, ModalConfirmAction, ArchivedRoles },
  data() {
    return {
      sectors: [],
      rolesHierarchy: [],
      productsLegalConsultation: [],
      loadingRoles: false,
      model: Acigh,
      selectedAgent: {},
      legalSearch: {},
      loadingAcgihModal: false,
      scrollBarPosition: 0,
      productId: null,
      userPreferencesId: null,
      agentsWithoutProduct: [],
      tabName: 'Limites prevencionistas',
      titleArchive: '',
      descriptionArchive: '',
      loadingArchive: false,
      archiveSectorRoleId: null,
      archivedRolesSectorId: null
    }
  },
  created() {
    const breadcrumb = {
      tab: 'PreventionistLimits',
      page: 'Consulta Legal',
      subPage: {
        name: 'Consulta Legal',
        active: false
      },
      tabs: [
        {
          name: 'Limites prevencionistas',
          active: true
        }
      ]
    }
    this.setBreadcrumb(breadcrumb)
  },
  computed: {
    ...mapGetters('legalSearch', {
      lookingForAgentsNotLinkedToProductAndRole: 'lookingForAgentsNotLinkedToProductAndRole'
    }),
    ...mapGetters('companyLegalConsultation', {
      importedCompany: 'importedCompany'
    }),
    ...mapGetters('userPreferences', {
      userPreferences: 'userPreferences'
    }),
    user() {
      return this.$store.getters['user/current']
    },
    summary() {
      return this.$store.getters['legalSearch/summary']
    }
  },
  async mounted() {
    const showModalAcceptinformationTab = await this.getAwareOfInformationByUser()
    if (showModalAcceptinformationTab) {
      setTimeout(() => {
        this.$bvModal.show('accept-information-tab')
      }, 100)
    }
    await this.setPageAgentsNotLinkedToProductAndRole(1)
    eventBus.$on('reloadLegalSearchReportTabs', async () => {
      await this.init()
    })
    await this.init()
  },
  beforeDestroy() {
    eventBus.$off('reloadLegalSearchReportTabs')
  },
  props: {},
  methods: {
    ...mapActions('sector', {
      handleGetHierarchyByCompanyLegalConsultation: 'handleGetHierarchyByCompanyLegalConsultation',
      handleGetHierarchyByCompanyLegalConsultationNotLinkedSector: 'handleGetHierarchyByCompanyLegalConsultationNotLinkedSector',
      handleOpenSector: 'handleOpen',
    }),
    ...mapActions('role', {
      handleOpenRole: 'handleOpen',
      handleOpenRoleWithoutSector: 'handleOpenPreventionistLimits',
      handleUpdateRiskOpenSectorRole: 'handleUpdateRiskOpenSectorRole',
      handleUpdateRiskOpenRole: 'handleUpdateRiskOpenRole',
      handleArchiveSectorRole: 'handleArchive',
    }),
    ...mapActions('product', {
      handlProductUpdateOpen: 'handleUpdateOpen',
    }),
    ...mapActions('productLegalConsultation', {
      productLegalConsultationGetWithoutRolesByCompany: 'productLegalConsultationGetWithoutRolesByCompany',
      handleUpdateOpenProductLegalConsultation: 'handleUpdateOpen',
    }),
    ...mapActions('userPreferences', {
      handleGetUserPreferences: 'handleGetUserPreferences',
      handleUpdateTabSummaryRiskOpen: 'handleUpdateTabSummaryRiskOpen'
    }),
    ...mapActions('userAwareOfInformation', {
      handleGetAwareOfInformationByUser: 'handleGetAwareOfInformationByUser'
    }),
    ...mapActions('legalSearch', {
      loadAgentsPreventionistLimits: 'loadAgentsPreventionistLimits',
      setPageAgentsNotLinkedToProductAndRole: 'setPageAgentsNotLinkedToProductAndRole',
      handleGetAgentsWithoutProduct: 'handleGetAgentsWithoutProduct',
    }),
    ...mapActions('breadcrumb', {
      setBreadcrumb: 'setBreadcrumb',
    }),
    async init() {
      this.loadingRoles = true
      await Promise.all([
        await this.getSectorsByCompanyLegalConsultation(),
        await this.getRolesHierarchyByCompanyLegalConsultation(),
        await this.getProductLegalConsultationHierarchizedByCompany(),
        await this.loadAgentsWithoutProduct(),
        await this.loadTabSummaryRiskPreferences()
      ])
      this.loadingRoles = false
    },

    async getProductLegalConsultationHierarchizedByCompany() {
      try {
        if (this.importedCompany && this.importedCompany._id) {
          const { data } = await this.productLegalConsultationGetWithoutRolesByCompany(this.importedCompany._id)
          const { items } = data || {}
          this.productsLegalConsultation = items || []
        } else {
          this.productsLegalConsultation = []
        }
      } catch (e) {
        // silent
      }
    },

    async loadAgentsWithoutProduct() {
      const { data } = await this.handleGetAgentsWithoutProduct(this.user.id)
      const { items } = data || {}
      this.agentsWithoutProduct = items
    },

    async getSectorsByCompanyLegalConsultation() {
      try {
        const { _id: companyLegalConsultationId } = this.importedCompany || {}
        if (companyLegalConsultationId) {
          const { data: dataResponse } = (await this.handleGetHierarchyByCompanyLegalConsultation(companyLegalConsultationId)) || {}
          const { items } = dataResponse || {}
          this.sectors = items || []
        } else {
          this.sectors = []
        }
      } catch (e) {
        this.loadingRoles = false
      }
    },

    async getRolesHierarchyByCompanyLegalConsultation() {
      try {
        const { _id: companyLegalConsultationId } = this.importedCompany || {}
        if (companyLegalConsultationId) {
          const { data: dataResponse } = (await this.handleGetHierarchyByCompanyLegalConsultationNotLinkedSector(companyLegalConsultationId)) || {}
          const { items } = dataResponse || {}
          this.rolesHierarchy = items || []
        } else {
          this.rolesHierarchy = []
        }
      } catch (e) {
        this.loadingRoles = false
      }
    },

    async toggleRoleOpen(roleItem) {
      try {
        if (!roleItem || !roleItem.role || !roleItem.role._id) return
        this.loadingRoles = true
        await this.handleOpenRoleWithoutSector(roleItem.role._id)
        await this.getRolesHierarchyByCompanyLegalConsultation()
      } catch (e) {
        // silent
      } finally {
        this.loadingRoles = false
      }
    },

    async toggleRoleRiskOpen(roleItem, riskField) {
      try {
        if (!roleItem || !roleItem.role || !roleItem.role._id) return
        this.loadingRoles = true
        const newValue = !roleItem[riskField]
        this.$set(roleItem, riskField, newValue)
        await this.handleUpdateRiskOpenRole({
          _id: roleItem.role._id,
          [riskField]: newValue,
        })
        await this.getRolesHierarchyByCompanyLegalConsultation()
      } catch (e) {
        // silent
      } finally {
        this.loadingRoles = false
      }
    },

    async toggleRoleProductOpen(product) {
      try {
        const { productLegalConsultationId, open } = product || {}
        if (!productLegalConsultationId) return
        this.loadingRoles = true
        await this.handleUpdateOpenProductLegalConsultation({ _id: productLegalConsultationId, open: !open })
        await this.getRolesHierarchyByCompanyLegalConsultation()
      } catch (e) {
        // silent
      } finally {
        this.loadingRoles = false
      }
    },

    async loadTabSummaryRiskPreferences() {
      try {
        await this.handleGetUserPreferences(this.user.id)
        const { _id } = this.userPreferences || {}
        this.userPreferencesId = _id
      } catch (e) {
        // silent
      }
    },

    showModalArchivedRoles(sector, event) {
      event.stopPropagation()
      this.archivedRolesSectorId = sector._id
      setTimeout(() => {
        this.$bvModal.show('archivedRoles')
      }, 100)
    },

    showModalArchiveRole(sectorRole, sector, event) {
      event.stopPropagation()
      const { role, _id: sectorRoleId } = sectorRole
      this.archiveSectorRoleId = sectorRoleId
      this.titleArchive = 'Arquivar cargo'
      this.descriptionArchive = `${sector.unitName ? `<strong>Unidade:</strong> ${sector.unitName}<br/>` : ''}<strong>Setor:</strong> ${sector.name}<br/><br/>Essa ação vai arquivar o cargo <strong>${role.name}</strong> e as informações dele neste setor.<br/><br/>Ele deixará de ser mostrado nas abas GRO, Laudo de insalubridade, Limites prevencionistas, LTCAT e PCMSO. Você poderá desarquivá-lo depois.<br/><br/>Deseja realmente finalizar esta ação?`
      this.$bvModal.show('archiveRole')
    },

    async archiveRole() {
      try {
        this.loadingArchive = true
        const { data, status } = await this.handleArchiveSectorRole({ sectorRoleId: this.archiveSectorRoleId, tab: this.tabName })
        this.loadingArchive = false
        this.$bvModal.hide('archiveRole')
        let message = data.message
        let variant = 'success'
        if (status !== 200) {
          message = data.errors
          variant = 'danger'
        }
        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        await this.init()
      } catch (e) {
        // silent
      }
    },

    async toggleChemicalExpanded(field) {
      try {
        this.loadingRoles = true
        await this.handleUpdateTabSummaryRiskOpen({
          _id: this.userPreferencesId,
          [field]: !this.userPreferences[field]
        })
        await this.handleGetUserPreferences(this.user.id)
      } catch (e) {
        // silent
      } finally {
        this.loadingRoles = false
      }
    },

    async toggleSectorOpen(sectorId) {
      try {
        if (!sectorId) return
        this.loadingRoles = true
        await this.handleOpenSector(sectorId)
        await this.getSectorsByCompanyLegalConsultation()
      } catch (e) {
        // silent
      } finally {
        this.loadingRoles = false
      }
    },

    async toggleSectorRoleOpen(sectorRoleId) {
      try {
        if (!sectorRoleId) return
        this.loadingRoles = true
        await this.handleOpenRole(sectorRoleId)
        await this.getSectorsByCompanyLegalConsultation()
      } catch (e) {
        // silent
      } finally {
        this.loadingRoles = false
      }
    },

    async toggleProductOpen(product) {
      try {
        const { _id, open } = product || {}
        if (!_id) return
        this.loadingRoles = true
        await this.handlProductUpdateOpen({ _id, open: !open })
        await this.getSectorsByCompanyLegalConsultation()
      } catch (e) {
        // silent
      } finally {
        this.loadingRoles = false
      }
    },

    async toggleProductLegalConsultationOpen(item) {
      try {
        const { _id, open } = item || {}
        if (!_id) return
        this.loadingRoles = true
        const newValue = !open
        this.$set(item, 'open', newValue)
        await this.handleUpdateOpenProductLegalConsultation({ _id, open: newValue })
        await this.getProductLegalConsultationHierarchizedByCompany()
      } catch (e) {
        // silent
      } finally {
        this.loadingRoles = false
      }
    },

    async toggleRiskOpen(sectorRole, riskField) {
      try {
        if (!sectorRole || !sectorRole._id) return
        this.loadingRoles = true
        const newValue = !sectorRole[riskField]
        this.$set(sectorRole, riskField, newValue)
        await this.handleUpdateRiskOpenSectorRole({
          _id: sectorRole._id,
          [riskField]: newValue,
        })
        await this.getSectorsByCompanyLegalConsultation()
      } catch (e) {
        // silent
      } finally {
        this.loadingRoles = false
      }
    },

    getRolesLegalsearches(sectorRole, risk) {
      const { role } = sectorRole || {}
      const { rolesLegalsearches } = role || {}
      if (!rolesLegalsearches || rolesLegalsearches.length <= 0) {
        return false
      }
      return rolesLegalsearches.filter((x) => x.riskType == risk).length > 0
    },

    getAgentsByRisk(sectorRole, risk) {
      const { role } = sectorRole || {}
      const { rolesLegalsearches } = role || {}
      if (!rolesLegalsearches || rolesLegalsearches.length <= 0) {
        return []
      }
      return rolesLegalsearches.filter((x) => x.riskType == risk)
    },


    displayInteractions(item) {
      if (
        item.acgih &&
        item.acgih.interactions &&
        item.acgih.interactions.length > 1
      ) {
        this.selectedAgent = item
        this.$bvModal.show('interactions-modal')
        this.scrollBarPosition = document.documentElement.scrollTop
      }
    },

    showModalSuggestionForImprovement(legalSearch) {
      try {
        this.legalSearch = legalSearch
        setTimeout((x) => {
          this.$bvModal.show('suggestion-for-improvement')
        }, 100)
        this.scrollBarPosition = document.documentElement.scrollTop
      } catch (e) {
        console.log(e)
      }
    },

    async saveSelectedInteractions(agent) {
      this.loadingAcgihModal = true
      await this.$store.dispatch('legalSearch/saveInteractions', agent)
      await this.$store.dispatch('legalSearch/load', this.user.id)
      await this.init()
      this.loadingAcgihModal = false
      this.$bvModal.hide('interactions-modal')
      window.scroll(0, this.scrollBarPosition)
      if (this.importedCompany && this.importedCompany._id) {
        this.$bvToast.toast(`As informações da empresa foram atualizadas.`, {
          title: 'Atenção',
          variant: 'success',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 6000
        })
      }
    },

    getInformationTwa(legalSearch) {
      const ltTwa = this.model.getValue('lt_twa', legalSearch)

      return ltTwa && ltTwa != '-'
        ? `${ltTwa} (ACGIH)`
        : '-'
    },

    getInformationStel(legalSearch) {
      const informationStel = []
      const ltStel = this.model.getValue('lt_stel', legalSearch)
      if (ltStel && ltStel != '-') {
        informationStel.push(ltStel)
      }
      const tetoStel = this.model.getValue('teto_stel', legalSearch)
      if (tetoStel && tetoStel != '-') {
        informationStel.push('Teto')
      }
      return informationStel.length > 0
        ? `${informationStel.join(', ')} (ACGIH)`
        : '-'
    },

    formatNotationsBaseDoTlv(legalSearch) {
      const list = []
      const notations = this.model.getValue('notations', legalSearch)
      if(notations && notations != '-'){
        list.push(notations)
      }
      const baseDoTlv = this.model.getValue('base_do_tlv', legalSearch)
      if(baseDoTlv && baseDoTlv != '-'){
        list.push(baseDoTlv)
      }

      const relevance = list.join(' ')
      const replaceBr = new RegExp('<br/>', 'g')
      return relevance ? relevance.replace(replaceBr, ' ') : '-'
    },

    async getAwareOfInformationByUser() {
      try {
        const { data: dataResponse } = await this.handleGetAwareOfInformationByUser(this.user.id)
        const { data } = dataResponse
        return !(data && data._id)
      } catch (e) {

      }
    },

    async showModalAgentPercentage(product) {
      try {
        const { productLegalConsultationId } = product || {}
        this.productId = productLegalConsultationId || (product && product._id) || null
        setTimeout(() => {
          this.$bvModal.show('agentPercentage')
        }, 100)
      } catch (e) {
      }
    }
  }

}
</script>

<style lang='scss' scoped>
.limits {
  font-weight: 400;
  font-size: 15px;
  color: #808080;
}

.role {
  background: #BDEAFF !important;
  min-height: 60px !important;
  margin-top: 1px !important;

  .name {
    color: var(--navy-blue) !important;
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 700 !important;
    text-align: center !important;
  }

  .btn-options {
    border-radius: 5px !important;
    border: 2px solid var(--navy-blue) !important;
    background: transparent !important;
    width: 100px !important;
    text-align: center !important;
  }

  .options {
    border-radius: 8px !important;
    width: 220px !important;
  }

  .btn-options-text {
    color: var(--navy-blue) !important;
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 700 !important;
  }
}

.rotate {
  transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
}

.transition {
  -webkit-transition: -webkit-transform 0.5s ease-in-out;
  -ms-transition: -ms-transform 0.5s ease-in-out;
  transition: transform 0.5s ease-in-out;
}

.pulse-gro-chevron-up {
  -webkit-animation: pulse-gro 1s infinite cubic-bezier(0.66, 0, 0, 1);
  -moz-animation: pulse-gro 1s infinite cubic-bezier(0.66, 0, 0, 1);
  -ms-animation: pulse-gro 1s infinite cubic-bezier(0.66, 0, 0, 1);
  animation: pulse-gro 1s infinite cubic-bezier(0.66, 0, 0, 1);
  box-shadow: 0 0 0 0 #ed9121;
  border-radius: 4px;
  margin-bottom: 4px !important;
  margin-top: 4px !important;
}

.pulse-gro {
  -webkit-animation: pulse-gro 1s infinite cubic-bezier(0.66, 0, 0, 1);
  -moz-animation: pulse-gro 1s infinite cubic-bezier(0.66, 0, 0, 1);
  -ms-animation: pulse-gro 1s infinite cubic-bezier(0.66, 0, 0, 1);
  animation: pulse-gro 1s infinite cubic-bezier(0.66, 0, 0, 1);
  box-shadow: 0 0 0 0 #bc0000;
  border-radius: 4px;
  margin-bottom: 4px !important;
  margin-top: 4px !important;
}

@-webkit-keyframes pulse-gro {
  to {
    box-shadow: 0 0 0 8px rgba(232, 76, 61, 0);
  }
}

@-moz-keyframes pulse-gro {
  to {
    box-shadow: 0 0 0 8px rgba(232, 76, 61, 0);
  }
}

@-ms-keyframes pulse-gro {
  to {
    box-shadow: 0 0 0 8px rgba(232, 76, 61, 0);
  }
}

@keyframes pulse-gro {
  to {
    box-shadow: 0 0 0 8px rgba(232, 76, 61, 0);
  }
}

.product {
  min-height: 60px;
  margin-top: 1px;
  margin-bottom: 2px;

  .name {
    color: var(--navy-blue);
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    text-align: center;
  }

  .btn-options {
    border-radius: 5px !important;
    border: 2px solid var(--navy-blue);;
    background: transparent !important;
    width: 100px;
    text-align: center;
  }

  .options {
    border-radius: 8px !important;
    width: 290px !important;
  }

  .btn-options-text {
    color: var(--navy-blue);
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
  }

  .btn-product {
    border-radius: 5px !important;
    border: 2px solid var(--navy-blue);
    background: transparent;
    padding: 7px 5px;
    color: var(--navy-blue);
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
  }

  .tr-title {
    font-weight: 600;
    font-size: 16px;
    color: #262626;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #EAEAEA;

    margin-left: 10px;
  }
}

.headerTable {
  vertical-align: middle;
  background: #EAECF0;
  padding: 10px;
}

.width-10-percent {
  width: 10% !important;
  padding: 10px 0;
}

.width-20-percent {
  width: 20% !important;
}

.width-30-percent {
  width: 30% !important;
}

.width-40-percent {
  width: 40% !important;
}

.btn-action {
  border: none;
}

.cas-agent {
  font-weight: 500;
  font-size: 15px;
  color: #808080;
}

.table-td {
  padding: 5px 0 !important;
  background: #FFFFFF !important;
  border-bottom: 1px solid #EAECF0;
}

.btn-termsofuses {
  border-radius: 5px;
  background: #FFFFFF !important;
  border: 1.5px solid #022245 !important;
  height: 44px !important;
  width: 44px !important;
  margin: 2.5px !important;
  padding: 6px !important;

  svg {
    path {
      fill: var(--navy-blue) !important;
    }
  }

  .btn-icon {
    color: var(--navy-blue) !important;
  }

  &:hover {
    background: var(--navy-blue) !important;

    svg {
      path {
        fill: #FFFFFF !important;
      }
    }
  }
}

.btn-termsofuses-not-filled {
  border-radius: 5px;
  background: #FFFFFF !important;
  border: 1.5px solid #CD0000 !important;
  height: 44px !important;
  width: 44px !important;
  margin: 2.5px !important;
  padding: 6px !important;

  svg {
    path {
      fill: #CD0000 !important;
    }
  }

  &:hover {
    background: #CD0000 !important;

    svg {
      path {
        fill: #FFFFFF !important;
      }
    }
  }
}

.margin-left-25 {
  margin-left: 25px;
}

.sector {
  background: #04A8F3 !important;
  margin-top: 1px !important;
  min-height: 60px !important;

  .name {
    color: #FFFFFF !important;
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 700 !important;
    text-align: center !important;
  }
}

.cargo-header {
  background: #BDEAFF;
  min-height: 60px;
}

.cargo-name {
  font-weight: 700;
  font-size: 16px;
  color: #262626;
}

.risk-text {
  font-weight: 700;
  font-size: 16px;
  color: #262626;
}

.risk-chemical {
  background: rgba(4, 168, 243, 0.4) !important;
  margin-top: 1px;
}

.risk-physical {
  background: #CCE5D2 !important;
  margin-top: 1px;
}

.risk-biological {
  background: #E3BEB0 !important;
  margin-top: 1px;
}

.btn-expand-collapse-navy-blue {
  background: transparent;
  border: 1px solid #022245;
  border-radius: 6.25px;
  font-weight: 600;
  padding: 10px;
}

.btn-information-filled-in {
  border-radius: 5px;
  background: #FFFFFF !important;
  border: 1px solid #022245 !important;
  height: 48px !important;
  width: 48px !important;
  padding: 6px !important;

  svg {
    path {
      fill: var(--navy-blue) !important;
    }
  }
  .btn-icon{
    color: var(--navy-blue) !important;
  }
  &:hover {
    background: var(--navy-blue) !important;

    svg {
      path {
        fill: #FFFFFF !important;
      }
    }
  }
}

</style>
